import { ComparePage } from "./ComparePage.js";

export default ComparePage;
